module.exports = __webpack_public_path__ + "static/img/赵瑞.25895de.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/st/赵瑞.jpg
// module id = LDcl
// module chunks = 1